import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { OrganizationPartService } from './organization-part.service';
import * as OrganizationPartActions from './organization-part.actions';

@Injectable()
export class OrganizationPartEffects {
    loadOrganizationParts$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(OrganizationPartActions.fetchOrganizationParts),
            mergeMap(({ organizationId }) =>
                this.organizationPartService.fetchOrganizationParts(organizationId).pipe(
                    map((organizationParts) =>
                        OrganizationPartActions.fetchOrganizationPartsSuccess({ organizationParts })
                    ),
                    catchError((error) => of(OrganizationPartActions.fetchOrganizationPartsFailed({ error })))
                )
            )
        );
    });

    loadOrganizationPartsByIds$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(OrganizationPartActions.fetchOrganizationPartsByIds),
            mergeMap(({ organizationPartIds }) => {
                return this.organizationPartService.fetchOrganizationPartsByIds(organizationPartIds).pipe(
                    map((organizationParts) => {
                        return OrganizationPartActions.fetchOrganizationPartsByIdsSuccess({ organizationParts });
                    }),
                    catchError((error) => {
                        return of(OrganizationPartActions.fetchOrganizationPartsByIdsFailed({ error }));
                    })
                );
            })
        );
    });

    constructor(
        private actions$: Actions,
        private organizationPartService: OrganizationPartService
    ) {}
}
